<template>
    <a href="#" @click.prevent="openPopup">
        <slot></slot>
    </a>
</template>

<script>
    import {eventBus} from "../eventBus";

    export default {
        name: "PopOpenLink",

        props: {
            open: {type: String, required: true},
            toggle: {type: Boolean, default: false, required: false}
        },
        data() {
            return {
                opened: false
            };
        },

        methods: {
            openPopup() {
                if( this.toggle && this.opened) {
                    this.opened = false;
                    eventBus.$emit('closePopup', this.open);
                }else {
                    this.opened = true;
                    eventBus.$emit('openPopup', this.open);
                }
            }
        }
    }
</script>

<style scoped>

</style>